export default {
  data() {
    return {
      timer: null,
      isPolling: true,
    }
  },
  watch: {
    'selectedList.length': function(newVal) {
      if (newVal > 0) {
        this.stopPolling()
      } else {
        this.startPolling(this.polling)
      }
    }
  },
  methods: {
    startPolling(pollingMethod) {
      // 本地运行时不实时更新，方便调试
      if (['local', 'dev'].includes(process.env.VUE_APP_CURRENT_MODE)) return
      if (this.timer) return
      this.isPolling = true
      this.timer = setInterval(() => {
        if (this.isPolling) {
          pollingMethod()
        }
      }, 5000)
    },
    stopPolling() {
      this.isPolling = false
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
  },
  beforeDestroy() {
    this.stopPolling()
  },
}
